(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('choicePossRule', {
        templateUrl: 'views/components/views/choicePossRule/choicePossRule.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'choicePossRuleService', 'choicePossRulesRunService', 'choicePossRulesService', 'typeaheadService', function ($stateParams, stateService, translateService, modalService, choicePossRuleService, choicePossRulesRunService, choicePossRulesService, typeaheadService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let choicePossRuleKeyno = $stateParams.choicepossrule_keyno;

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                choicePossRuleKeyno: choicePossRuleKeyno,
                productIdButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => gotoProduct() }
                ],
                modelButtons: [
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('models') }
                ],
                modelButtonsGoto: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('model_id') },
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('models') },
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('modelmenu', { model_id: vm.model.edit.model_id }) }
                ],
                productNameSelectButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('prod_id') }
                ],
                fabricsButtons: [
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('furniturefabricss') }
                ],
                fabricsButtonsGoto: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('furniturefabrics_id') },
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('furniturefabricss') },
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('furniturefabrics', { furniturefabrics_id: vm.model.edit.furniturefabrics_id }) }
                ],
                chosenProductButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('choosed_prod_id') },
                ],
                chosenProductButtonsGoto: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('choosed_prod_id') },
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => gotoChosenProduct() }
                ],
                edit: {},
                selectListProductChoices: [],
                selectListModels: [],
                selectListProductNames: [],
                selectListFurnitureFabrics: [],
                selectListChosenProducts: [],
                lockedSave: false,
                lockedDelete: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTIONS

            async function loadProductNames() {
                if (vm.model.edit.model_id?.trim() && vm.model.edit.nbr_of_products < 200) {
                    return vm.model.selectListProductNames = await choicePossRulesService.listProductNames(vm.model.edit);
                }
            }

            async function retrieveChoiceProductId() {
                if (vm.model.edit.choice_prod_id?.trim()) {
                    return vm.model.edit.nbr_of_furniturefabrics = (await choicePossRulesService.changeChoiceProductId({ choice_prod_id: vm.model.edit.choice_prod_id }))[0].nbr_of_furniturefabrics;
                }
            }

            async function loadFurnitureFabrics() {
                if (vm.model.edit.choice_prod_id?.trim() && vm.model.edit.nbr_of_furniturefabrics > 0) {
                    return vm.model.selectListFurnitureFabrics = await choicePossRulesService.listFurnitureFabrics({
                        add_all: '1',
                        choice_prod_id: vm.model.edit.choice_prod_id
                    });
                }
            }

            async function retrieveModelId() {
                if (vm.model.edit.model_id?.trim()) {
                    vm.model.edit.nbr_of_products = (await choicePossRulesService.changeModelId(vm.model.edit))[0].nbr_of_products;
                    return loadProductNames();
                }
            }

            async function loadChosenProducts() {
                if (vm.model.edit.choice_prod_id && vm.model.edit.furniturefabrics_id) {
                    return vm.model.selectListChosenProducts = await choicePossRulesService.listChosenProducts(vm.model.edit);
                }
            }

            async function loadEdit() {
                return vm.model.edit = (await choicePossRuleService.getEdit({ choicepossrule_keyno: choicePossRuleKeyno }))[0];
            }

            async function loadProductChoices() {
                vm.model.selectListProductChoices = await choicePossRulesRunService.listProductChoices();
            }

            async function loadModels() {
                vm.model.selectListModels = await choicePossRulesRunService.listModels({
                    add_all: '1',
                    show_inactive: '0'
                });
            }

            // #endregion LOAD PROCEDURE FUNCTIONS

            // #region MULTI CLEAR FUNCTION

            function clear(id) {
                switch (id) {
                    case 'model_id':
                        vm.model.edit.model_id = 'ALL';

                        if (vm.model.edit.model_id === 'ALL') {
                            vm.model.edit.prod_id = '';
                            vm.model.edit.prod_name = '';

                            retrieveModelId();
                        }
                        break;
                    case 'prod_id':
                        vm.model.edit.prod_id = '';
                        vm.model.edit.prod_name = '';
                        break;
                    case 'furniturefabrics_id':
                        vm.model.edit.furniturefabrics_id = 'ALL';
                        vm.model.edit.choosed_prod_id = '';
                        break;
                    case 'choosed_prod_id':
                        vm.model.edit.choosed_prod_id = '';
                        break;
                    default:
                        break;
                }
            }

            // #endregion MULTI CLEAR FUNCTION

            // #region DIRECTION FUNCTIONS

            function gotoProduct() {
                if (vm.model.edit.prod_id) {
                    choicePossRulesService.getProdKeyno({ prod_id: vm.model.edit.prod_id }).then((response) => {
                        if (response[0].prod_keyno) stateService.go('product', { prod_id: response[0].prod_keyno });
                    });
                }
            }

            function gotoChosenProduct() {
                if (vm.model.edit.choosed_prod_id?.trim()) {
                    choicePossRulesService.getProdKeyno({ prod_id: vm.model.edit.choosed_prod_id }).then((response) => {
                        if (response[0].prod_keyno) stateService.go('product', { prod_id: response[0].prod_keyno });
                    });
                }
            }

            // #endregion DIRECTION FUNCTIONS

            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            vm.typeaheadSearch = function (value, id) {
                switch (id) {
                    case 'prod_name':
                        vm.model.edit[id] = value;

                        return typeaheadService.searchProduct({
                            prod_name: vm.model.edit[id] || '',
                            webpage_name: stateService.getCurrentName(),
                            parm1: '0',
                            parm2: '0',
                            supplier_no: '0',
                            search_only_this_supplier: '0',
                            businessco_no: '0',
                            onlyonstock: '0',
                            model_id: vm.model.edit.model_id
                        });
                        break;
                    default:
                        break;
                }
            };

            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            // #region SELECTED VALUE FUNCTION

            vm.onTypeaheadSelected = function (item, id) {
                switch (id) {
                    case 'prod_name':
                        if (item) {
                            vm.model.edit.prod_id = item?.item_id ?? '';
                            vm.model.edit.prod_name = item?.item_name ?? '';
                        } else {
                            vm.onTypeaheadClear('prod_name');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion SELECTED VALUE FUNCTION

            // #region CHANGED VALUE FUNCTION

            vm.onTypeaheadChanged = function (value, item, id) {
                switch (id) {
                    case 'prod_name':
                        vm.model.edit.prod_name = value;

                        if (value) {
                            if (item?.item_id) {
                                vm.model.edit.prod_id = item.item_id;
                            }
                        } else {
                            vm.onTypeaheadClear('prod_name');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion CHANGED VALUE FUNCTION

            // #region CLEAR VALUE FUNCTION

            vm.onTypeaheadClear = function (id) {
                switch (id) {
                    case 'prod_name':
                        vm.model.edit.prod_id = '';
                        vm.model.edit.prod_name = '';
                        break;
                    default:
                        break;
                }
            };

            // #endregion CLEAR VALUE FUNCTION

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                choicePossRuleService.saveObj(vm.model.edit).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedSave = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedSave = false;
                        stateService.back();
                    }
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(() => {
                    choicePossRuleService.deleteItem(vm.model.edit).then(() => {
                        vm.model.lockedDelete = false;
                        stateService.back();
                    }, () => {
                        vm.model.lockedDelete = false;
                    });
                }, () => {
                    vm.model.lockedDelete = false;
                });
            };

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region ON CHANGE FUNCTIONS

            vm.onProductNameSelected = function (value) {
                vm.model.edit.prod_id = value;

                if (value) {
                    let productItem = vm.model.selectListProductNames.find((item) => item?.item_id === vm.model.edit.prod_id);

                    if (productItem?.item_name) vm.model.edit.prod_name = productItem.item_name;
                }
            }

            vm.onModelChanged = function (value) {
                vm.model.edit.model_id = value;

                if (value) {
                    clear('prod_id');
                    retrieveModelId();
                }
            }

            vm.onChoiceProductChanged = async function (value) {
                vm.model.edit.choice_prod_id = value;

                if (value) {
                    clear('furniturefabrics_id');
                    await loadChosenProducts();
                    await retrieveChoiceProductId();
                    loadFurnitureFabrics();
                }
            }

            vm.onFurnitureFabricsChanged = function (value) {
                vm.model.edit.furniturefabrics_id = value;

                if (value) {
                    loadChosenProducts();

                    if (vm.model.edit.furniturefabrics_id === 'ALL') clear('choosed_prod_id');
                }
            }

            // #endregion ON CHANGE FUNCTIONS

            // #region ANGULAR LIFECYCLE FUNCTIONS

            vm.$onInit = async function () {
                translate();
                loadProductChoices();
                loadModels();
                await loadEdit();

                retrieveModelId();
                loadChosenProducts();
                await retrieveChoiceProductId();
                loadFurnitureFabrics();
            }

            // #endregion ANGULAR LIFECYCLE FUNCTIONS

        }]
    });
})();
